/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */
import GentleAppState from '../common/appstate';

var GentleLang = {
    persona:{
        TOMMY: 'tomy',
        PAPA: 'papa',
    },
    lang:{
        KR : 'KR',
        ENG : 'EN',    
    },
    type: {
        NotSupported: 'NotSupported',
        Sorry: 'Sorry',
        Faq: 'Faq', //퀵메뉴 faq
        Invite: 'Invite', //퀵메뉴 가입초대
        VisitVideo: 'VisitVideo',
        NextProducts: 'NextProducts',
        CheckIncome: 'CheckIncome', // 수당조회
        LowerSales: 'LowerSales', // 하위매출 조회
        CheckApprove: 'CheckApprove', 
        FontSize: 'FontSize',
        Small: 'Small',
        Medium: 'Medium',
        Large: 'Large',
        Orders: 'Orders',
        UpdateDate: 'UpdateDate',
        GoHome: 'GoHome',
        Notice: 'Notice',
        Option: 'Option',
        Amount: 'Amount',
        OptionSelect: 'OptionSelect',
        OptionAdd: 'OptionAdd',
        Login: 'Login',
        Logout: 'Logout',
        Hello: 'Hello',
        Hello2: 'Hello2',
        Bye: 'Bye',    
        Cart: 'Cart',
        AddCart: 'AddCart',
        ProductDetailView: 'ProductDetailView',
        NewProduct: 'NewProduct',
        BestProduct: 'BestProduct', 
        ButtonMore: 'ButtonMore',
        ButtonLogin: 'ButtonLogin',
        ButtonLogout: 'ButtonLogout',
        ButtonNewProduct: 'ButtonNewProduct',
        ButtonPlan: 'ButtonPlan',
        ButtonLowerSales: 'ButtonLowerSales',
        ButtonRecommendProduct: 'ButtonRecommendProduct',
        ButtonRecentIncome: 'ButtonRecentIncome',
        DateFormat: 'DateFormat',
        Left: 'Left',
        Right: 'Right',
        Total: 'Total',     // 합계
        Holdover: 'Holdover',   // 이월
        TodaySales: 'TodaySales', // 오늘의 매출
        YesterdaySales: 'YesterdaySales', // 어제의 매출    
        Position: 'Position',
        MonthDate: 'MonthDate', // '{month}월{day}일',
        Category: 'Category', // '카테고리',
        TimeAm: 'TimeAm',//  '오전 {h}:{m}',
        TimePm: 'TimePm',// '오후 {h}:{m}',
        VisitCount: 'VisitCount',
        Ordered: 'Ordered',
        Paid: 'Paid',
        CancelOrder: 'CancelOrder',
        CancelPay: 'CancelPay',
        Unpaid: 'Unpaid',
        ReadyShip: 'ReadyShip',
        Delivery: 'Delivery',
        DeliveryDone: 'DeliveryDone',
        SmallSales: 'SmallSales',   // 소실적
        Sponsor: 'Sponsor', // 후원인
        CustNo: 'CustNo',   // 회원번호
        CopiedURL: 'CopiedURL', // 상품 링크가 복사되었습니다.
        FailedCopyURL: 'FailedCopyURL',
        MyMember: 'MyMember',   // 관심회원
        TotalPv: 'TotalPv',
        SearchProduct: 'SearchProduct',

        PositionSales: 'PositionSales',// '판매원',
        PositionAgent: 'PositionAgent',// '에이전트',
        PositionSalesMaster: 'PositionSalesMaster',// '세일즈마스터',
        PositionDiamond: 'PositionDiamond',// '다이아몬드',
        PositionRose: 'PositionRose',// '샤론로즈',
        PositionStar: 'PositionStar',// '스타',
        PositionRoyal: 'PositionRoyal',// '로얄',
        PositionCrown: 'PositionCrown',// '크라운',
        PositionImperial: 'PositionImperial', // 임페리얼

        AtomyNewProduct: 'AtomyNewProduct',
        AtomyBestProduct: 'AtomyBestProduct',
        
        FallbackBotAny: 'FallbackBotAny',
        FallbackBotMember: 'FallbackBotMember',
        FallbackThird: 'FallbackBotThird',

        CurrencyFormat: 'CurrencyFormat',   // ...원
        CurrencyFormat1: 'CurrencyFormat1',   // ...원
        CurrencyFormat2: 'CurrencyFormat2',   // ...원
        CurrencyFormat3: 'CurrencyFormat3',   // ...원
        CurrencyFormatBold: 'CurrencyFormatBold', // <strong class="bold"></strong>

        BestKeyword: 'BestKeyword', // '인기상품 키워드',
        Views: 'Views',// '조회수',
        
        TelNumber: 'TelNumber',// '전화번호',
        Address: 'Address',// '주소'
        Count: 'Count', // '{num}건 / 총 {total}건',
        CardNumber: 'CardNumber',// '카드번호',
        ChatPlaceholder: "ChatPlaceholder",

        Items: 'Items', // 몇건
        UpdateNotice: 'UpdateNotice', //업데이트 토스트 알림 문구
        UpdateDisable: 'UpdateDisable', //업데이트가 되며 사용할수 없는 기능에 대한 문구. 
    },
    tomy:{
        kr: {
            Sorry: '<b>[공지] 챗봇 로그인 장애 안내</b><br>현재 일시적인 오류로 인해 챗봇 로그인 이용이 원활하지 않습니다.<br>신속하게 원인을 파악하여 빠른 시일 내에 복구할 수 있도록 노력하고 있습니다.<br>이용에 불편을 드려 죄송하며, 복구가 완료되는 대로 다시 안내 드리겠습니다.<br>※ 로그인 없이 이용 가능한 서비스는  정상적으로 이용하실 수 있습니다.<br>감사합니다.',
            NotSupported: '현재 이 기능은 제공하지 않으며 향후 업데이트를 통해 제공할 예정입니다. 이용에 참고 부탁드립니다.',
            CheckIncome: '수당조회',
            LowerSales: '하위매출 조회',
            CheckApprove: '승인잔액 조회', 
            FontSize: '글자크기',
            Small: '작게',
            Medium: '중간',    
            Large: '크게',
            Orders: '주문내역',
            UpdateDate: '판매일자 변경',
            GoHome: '처음으로',
            Notice: '공지사항',
            Option: '옵션',
            Amount: '수량',
            OptionSelect: '옵션 선택',
            OptionAdd: '이 상태로 장바구니 담기',
            Login: '로그인',
            Logout: '로그아웃',
            Hello : '애터미 Village에 온 걸 환영해요.<br>쇼핑 여정에 함께할 PAPA 파파예요.',
            Hello : '안녕하세요, PAPA입니다.',
            Hello2: '<b>{name}님</b>, 반갑습니다.',
            Bye : '잘가세요',  
            Cart: '장바구니', 
            NewProduct: '신상품',
            BestProduct: '인기상품',
            ButtonMore: '더보기',
            ButtonLogout: '로그아웃하기',
            Left: '좌',
            Right: '우',
            Total: '합계',     // 합계
            Holdover: '이월',   // 이월
            TodaySales: '금일 매출 PV', // 오늘의 매출
            YesterdaySales: '전일 매출 PV', // 어제의 매출    
            Position: '직급',
            MonthDate: '{month}월{day}일',
            TimeAm: '오전 {h}:{m}',
            TimePm: '오후 {h}:{m}',
            VisitCount: '조회수 {count}',
            Ordered: '주문완료',
            Paid: '결제완료',
            CancelOrder: '주문취소',
            CancelPay: '결제취소',
            Unpaid: '미결제마감',
            ReadyShip: '배송준비중',
            Delivery: '배송중',
            DeliveryDone: '배송완료',
            SmallSales: '소실적',   // 소실적
            Sponsor: '후원인', // 후원인
            CustNo: '회원번호',   // 회원번호
            CopiedURL: '상품 링크가 복사되었습니다.', 
            FailedCopyURL: '상품 링크 복사에 실패했습니다.',
            MyMember: '관심회원',   // 관심회원
            SalesCur: '현재 매출',   // 현재 매출
            SalesTotal: '총 매출', // 총 매출

            PositionSales: '판매원',
            PositionAgent: '에이전트',
            PositionSalesMaster: '세일즈마스터',
            PositionDiamond: '다이아몬드마스터',
            PositionRose: '샤론로즈마스터',
            PositionStar: '스타마스터',
            PositionRoyal: '로얄마스터',
            PositionCrown: '크라운마스터',
            PositionImperial: '임페리얼마스터',
            ProductDetailView: '상품 상세보기',
            AddCart: '장바구니 담기',

            VisitVideo: '채널 애터미 영상 보러가기',
            TotalPv: '총 PV',
            SearchProduct: '상품 검색',

            NextProducts: '상품 더보기',
            ButtonLogin: '로그인하기',
    
            AtomyNewProduct: '애터미 신상품 보기',
            AtomyBestProduct: '애터미 인기상품 보기',

            FallbackBotAny: '흠... 제가 얘기할수 없는 부분이네요. 혹시 이런 것들이 궁금하진 않나요?',
            FallbackBotMember: '죄송합니다. 말씀을 이해하지 못했습니다. 혹시 이런걸 찾고 계신가요?',
            FallbackThird: '지금은 저보다 행복센터 상담 매니저님의 도움이 필요하실 것 같아요. 바로 연결해드리겠습니다.',
    
            ButtonNewProduct: '애터미 신상품 보기',
            ButtonPlan: '마케팅 플랜 알아보기',
            ButtonLowerSales: '하위매출 보기',
            ButtonRecommendProduct: '소실적 상품 추천받기',
            ButtonRecentIncome: '최근 수당 보기',
    
            CurrencyFormat: '{num}원',
            CurrencyFormat1: '<strong><em>{num}</em></strong> 원',
            CurrencyFormat2: '<strong>{num}</strong> 원',   // ...원
            CurrencyFormat3: '<strong class="price">{num}</strong>원',
            CurrencyFormatBold: '<strong class="bold">{num}</strong>원',

            Category: '카테고리',
            BestKeyword: '인기상품 키워드',
            Views: '조회수',
                
            TelNumber: '전화번호',
            Address: '주소',
            Count: '<strong><em class="cur">{count}</em>건</strong> / 총 <em class="total">{total}</em>건',
            CardNumber: '카드번호',
            ChatPlaceholder: "질문을 입력해주세요",
            Items: '{num}건',
            Faq: 'FAQ', //퀵메뉴 faq
            Invite: '상담사연결',
            UpdateNotice: '[챗봇이용제한안내]<br>앗 ! 보다 원활한 챗봇 이용을 위한 업데이트가 있을 예정이에요.<br>업데이트 시간동안은 챗봇 사용이 제한될 예정이니 사용에 참고 부탁드릴게요!<br>- 업데이트 일시 : 2022.05.13(금) 00시~02시<br> 감사합니다.',
            UpdateDisable: '현재 챗봇이 업데이트 중입니다.<br>그래서 요청하신 내용의 답변을<br> 드릴 수가 없어요…<br>하지만 행복센터 매니저와 연락하시면<br> 요청하신 내용에 대한 자세한 답변을 확인 하실 수 있어요!'

        },
        eng: {
            Sorry: '<b>[Notice] Temporary Chatbot Login Issue</b><br>We are currently experiencing a temporary issue with the chatbot login service.<br>We are actively working to identify and resolve the issue as quickly as possible.<br>We sincerely apologize for any inconvenience caused and will update you once the issue has been resolved.<br>※ Services available without login can still be accessed normally.<br>Thank you for your understanding.',
            NotSupported: 'This function is not currently available, but it is planned to be included in an upcoming update. Thank you for your understanding',
            SearchProduct: 'Product Search',
            CheckIncome: 'Commission Inquiry',
            LowerSales: 'Group Purchase Inquiry',
            CheckApprove: 'Approved Balance Inquiry', 
            FontSize: 'Font Size',
            Small: 'Small',
            Medium: 'Middle',    
            Large: 'Large',
            Orders: 'Order History',
            UpdateDate: 'Change Sales Date',
            GoHome: 'Return to the Beginning',
            Notice: 'Notice',
            Option: 'Option',
            Amount: 'Amount',
            OptionSelect: 'Choose an option',
            OptionAdd: 'Add to cart',
            Login: 'LOGIN',
            Logout: 'LOGOUT',
            Hello : 'Welcome to Atomy.',
            Hello2: 'Hello2',
            Bye : 'Good Bye',    
            Cart: 'Cart',
            NewProduct: 'New products',
            BestProduct: 'Best products',
            ButtonMore: 'View more',
            ButtonLogout: 'ButtonLogout',
            VisitVideo: 'VisitVideo',
            ProductDetailView: 'Detail view',
            AddCart: 'Add to cart',
    
            Sales3days: 'Sales3days',
            SalesAnotherDays: 'SalesAnotherDays',
            Left: 'Left',
            Right: 'Right',
            Total: 'Total',     // 합계
            Holdover: 'Holdover',   // 이월
            TodaySales: 'TodaySales', // 오늘의 매출
            YesterdaySales: 'YesterdaySales', // 어제의 매출 
            Position: 'Position',
            MonthDate: 'MonthDate', // '{month}월{day}일',
            TimeAm: 'am {h}:{m}',
            TimePm: 'pm {h}:{m}',
            VisitCount: 'VisitCount {count}',
            Ordered: '주문완료',
            Paid: '결제완료',
            CancelOrder: '주문취소',
            CancelPay: '결제취소',
            Unpaid: '미결제마감',
            ReadyShip: '배송준비중',
            Delivery: '배송중',
            DeliveryDone: '배송완료',
            SmallSales: 'Smaller leg',   // 소실적
            Sponsor: '후원인', // 후원인
            CustNo: '회원번호',   // 회원번호
            CopiedURL: '상품 링크가 복사되었습니다.',
            FailedCopyURL: '상품 링크 복사에 실패했습니다.',
            MyMember: 'interested member',   // 관심회원
            SalesCur: '현재 매출',   // 현재 매출
            SalesTotal: '총 매출', // 총 매출

            PositionSales: 'Sales',
            PositionAgent: 'agent',
            PositionSalesMaster: 'Sales Master',
            PositionDiamond: 'Diamond Master',
            PositionRose: 'Sharon Rose Master',
            PositionStar: 'Star Master',
            PositionRoyal: 'Royal Master',
            PositionCrown: 'Crown Master',
            PositionImperial: 'Imperial Master',
    
            ProductPre: 'ProductPre',
            NextProducts: 'Next',
    
            ButtonLogin: 'ButtonLogin',

            AtomyNewProduct: 'New products',
            AtomyBestProduct: 'Popular products',

            FallbackBotAny: 'FallbackBotAny',
            FallbackBotMember: 'FallbackBotMember',
            FallbackThird: 'FallbackBotThird',
    
            ButtonNewProduct: 'View new Atomy products',
            OrderList: 'OrderList',
            ButtonPlan: 'ButtonPlan',
            ButtonLowerSales: 'ButtonLowerSales',
            ButtonRecommendProduct: 'ButtonRecommendProduct',
            ButtonRecentIncome: 'ButtonRecentIncome',

            CurrencyFormat: '{num} KRW',
            CurrencyFormat1: '<strong><em>{num}</em></strong> KRW', 
            CurrencyFormat2: '<strong>{num}</strong> KRW',   // ...원
            CurrencyFormat3: '<strong class="price">{num}</strong> KRW',
            CurrencyFormatBold: '<strong class="bold">{num}</strong> KRW',
    
            Category: 'Category', // '카테고리',
            BestKeyword: 'Best keywords', // '인기상품 키워드',    

            NoticeBot: 'NoticeBot',// '새로운 공지사항이 있는지 확인해보세요.',
            Views: 'Views',// '조회수',        
    
            TelNumber: 'TelNumber',// '전화번호',
            Address: 'Address',// '주소'
            Count: 'Count', // '{num}건 / 총 {total}건',
    
            CardNumber: 'CardNumber',// '카드번호',
            ChatPlaceholder: "Please enter your question",
            Items: '{num}',
            TotalPv: 'Total PV',
            Faq: 'FAQ', //퀵메뉴 faq
            Invite: 'Contact Agent',
            UpdateNotice: '[챗봇이용제한안내]<br>앗 ! 보다 원활한 챗봇 이용을 위한 업데이트가 있을 예정이에요.<br>업데이트 시간동안은 챗봇 사용이 제한될 예정이니 사용에 참고 부탁드릴게요!<br>- 업데이트 일시 : 2022.05.13(금) 00시~02시<br> 감사합니다.',
            UpdateDisable: 'We are updating chatbot now.<br> Sorry about we can’t give you the answer...<br> But if you contact with the manager of Center,<br> you will get the answer from your request. '


        },    
    },
    papa:{
        kr: {
            Sorry: '<b>[공지] 챗봇 로그인 장애 안내</b><br>현재 일시적인 오류로 인해 챗봇 로그인 이용이 원활하지 않습니다.<br>신속하게 원인을 파악하여 빠른 시일 내에 복구할 수 있도록 노력하고 있습니다.<br>이용에 불편을 드려 죄송하며, 복구가 완료되는 대로 다시 안내 드리겠습니다.<br>※ 로그인 없이 이용 가능한 서비스는  정상적으로 이용하실 수 있습니다.<br>감사합니다.',
            NotSupported: '현재 이 기능은 제공하지 않으며 향후 업데이트를 통해 제공할 예정입니다. 이용에 참고 부탁드립니다.',
            CheckIncome: '수당조회',
            LowerSales: '하위매출 조회',
            CheckApprove: '승인잔액 조회', 
            FontSize: '글자크기',
            Small: '작게',
            Medium: '중간',    
            Large: '크게',
            Orders: '주문내역',
            UpdateDate: '판매일자 변경',
            GoHome: '처음으로',
            Notice: '공지사항',
            Option: '옵션',
            Amount: '수량',
            OptionSelect: '옵션 선택',
            OptionAdd: '이 상태로 장바구니 담기',
            Login: '로그인',
            Logout: '로그아웃',
            Hello : '애터미 Village에 온 걸 환영해요.<br>쇼핑 여정에 함께할 PAPA 파파예요.',
            Hello : '안녕하세요, PAPA입니다.',
            Hello2: '만나게 되어 반갑군요!',
            Bye : '잘가세요',  
            Cart: '장바구니', 
            NewProduct: '신상품',
            BestProduct: '인기상품',
            ButtonMore: '더보기',
            ButtonLogout: '로그아웃하기',
            Left: '좌',
            Right: '우',
            Total: '합계',     // 합계
            Holdover: '이월',   // 이월
            TodaySales: '금일 매출 PV', // 오늘의 매출
            YesterdaySales: '전일 매출 PV', // 어제의 매출    
            Position: '직급',
            MonthDate: '{month}월{day}일',
            TimeAm: '오전 {h}:{m}',
            TimePm: '오후 {h}:{m}',
            VisitCount: '조회수 {count}',
            Ordered: '주문완료',
            Paid: '결제완료',
            CancelOrder: '주문취소',

            PositionSales: '판매원',
            PositionAgent: '에이전트',
            PositionSalesMaster: '세일즈마스터',
            PositionDiamond: '다이아몬드',
            PositionRose: '샤론로즈',
            PositionStar: '스타',
            PositionRoyal: '로얄',
            PositionCrown: '크라운',
            PositionImperial: '임페리얼',
            ProductDetailView: '상품 상세보기',
            AddCart: '장바구니 담기',
    
            SmallSales: '소실적',   // 소실적
    
            VisitVideo: '채널 애터미 영상 보러가기',
            TotalPv: '총 PV',
            SearchProduct: '상품 검색',
            NextProducts: '상품 더보기',
    
            ButtonLogin: '로그인하기',

            AtomyNewProduct: '애터미 신상품 보기',
            AtomyBestProduct: '애터미 인기상품 보기',

            FallbackBotAny: '흠... 제가 얘기할수 없는 부분이네요. 혹시 이런 것들이 궁금하진 않나요?',
            FallbackBotMember: '죄송합니다. 말씀을 이해하지 못했습니다. 혹시 이런걸 찾고 계신가요?',
            
            FallbackThird: '흠, 꼭 찾아야 하는 게 있는 것 같네요! 그렇다면 행복센터 상담 매니저님을 연결해 드릴게요. 이야기를 나눠보세요.',
            // FallbackThird: '아래 버튼을 누르시면 행복센터 매니저와 상담하실 수 있습니다',
    
            ButtonNewProduct: '애터미 신상품 보기',
            OrderList: '주문내역 보기',
            ButtonPlan: '마케팅 플랜 알아보기',
            ButtonLowerSales: '하위매출 보기',
            ButtonRecommendProduct: '소실적 상품 추천받기',
            ButtonRecentIncome: '최근 수당 보기',
            CurrencyFormat: '{num}원',
            CurrencyFormat1: '<strong><em>{num}</em></strong> 원',
            CurrencyFormat2: '<strong>{num}</strong> 원',   // ...원
            CurrencyFormat3: '<strong class="price">{num}</strong> 원',
            CurrencyFormatBold: '<strong class="bold">{num}</strong>원',
    
            Category: '카테고리',
            BestKeyword: '인기상품 키워드',

            NoticeBot: '새로운 공지사항이 있는지 확인해보세요.',
            Views: '조회수',

            TelNumber: '전화번호',
            Address: '주소',
            Count: '{count}건 / 총 {total}건',
            CardNumber: '카드번호',
    
            MyMember: '관심회원',   // 관심회원
            Sponsor: '후원인', // 후원인
            CustNo: '회원번호',   // 회원번호
            CancelPay: '결제취소',
            Unpaid: '미결제마감',
            ReadyShip: '배송준비중',
            Delivery: '배송중',
            DeliveryDone: '배송완료',
            ChatPlaceholder: "질문을 입력해주세요",
            CopiedURL: '상품 링크가 복사되었습니다.',
            Items: '{num}건',
            Faq: 'FAQ', //퀵메뉴 faq
            Invite: '상담사연결',
            UpdateNotice: '[챗봇이용제한안내]<br>앗 ! 보다 원활한 챗봇 이용을 위한 업데이트가 있을 예정이에요.<br>업데이트 시간동안은 챗봇 사용이 제한될 예정이니 사용에 참고 부탁드릴게요!<br>- 업데이트 일시 : 2022.05.13(금) 00시~02시<br> 감사합니다.',
            UpdateDisable: '현재 챗봇이 업데이트 중입니다.<br>그래서 요청하신 내용의 답변을<br> 드릴 수가 없어요…<br>하지만 행복센터 매니저와 연락하시면<br> 요청하신 내용에 대한 자세한 답변을 확인 하실 수 있어요!'


        },
        eng: {
            Sorry: '<b>[Notice] Temporary Chatbot Login Issue</b><br>We are currently experiencing a temporary issue with the chatbot login service.<br>We are actively working to identify and resolve the issue as quickly as possible.<br>We sincerely apologize for any inconvenience caused and will update you once the issue has been resolved.<br>※ Services available without login can still be accessed normally.<br>Thank you for your understanding.',
            NotSupported: 'This function is not currently available, but it is planned to be included in an upcoming update. Thank you for your understanding',
            SearchProduct: 'Product Search',
            CheckIncome: 'Allowance inquiry',
            LowerSales: 'The Group Purchase inquiry',
            CheckApprove: 'Approval balance inquiry', 
            FontSize: 'Font Size',
            Small: 'Small',
            Medium: 'Middle',    
            Large: 'Large',
            Orders: 'Order History',
            UpdateDate: 'Change of Sale Date',
            GoHome: 'Return to the Beginning',
            Notice: 'Notice',
            Option: 'Option',
            Amount: 'Amount',
            OptionSelect: 'Choose an option',
            OptionAdd: 'Add to cart in this state',
            Login: 'LOGIN',
            Logout: 'LOGOUT',
            Hello : 'Welcome to Atomy.',
            Hello2: 'Hello2',
            Bye : 'Good Bye',    
            Cart: 'Cart',
            NewProduct: 'New products',
            BestProduct: 'Best products',
            ButtonMore: 'View more',
            ButtonLogout: 'ButtonLogout',
            VisitVideo: 'VisitVideo',
    
            ProductDetailView: 'Detail view',
            AddCart: 'Add to cart',
    
            Sales3days: 'Sales3days',
            SalesAnotherDays: 'SalesAnotherDays',
            Left: 'Left',
            Right: 'Right',
            Total: 'Total',     // 합계
            Holdover: 'Holdover',   // 이월
            TodaySales: 'TodaySales', // 오늘의 매출
            YesterdaySales: 'YesterdaySales', // 어제의 매출 
            Position: 'Position',
            MonthDate: 'MonthDate', // '{month}월{day}일',
            TimeAm: 'am {h}:{m}',
            TimePm: 'pm {h}:{m}',
            VisitCount: 'VisitCount {count}',
            Ordered: 'order completed',
            Paid: 'Payment completed',
            CancelOrder: 'order cancel',
            CancelPay: 'Payment cancel',
            Unpaid: 'non-payment closed',
            ReadyShip: 'Preparing for delivery',
            Delivery: 'Shipping',
            DeliveryDone: 'Order completed',
            SmallSales: 'Smaller leg',   // 소실적
            Sponsor: 'Sponsor', // 후원인
            CustNo: 'Membership number',   // 회원번호
            CopiedURL: 'The product link has been copied.',
            FailedCopyURL: 'Failed to copy product link.',
            MyMember: 'interested member',   // 관심회원
            SalesCur: 'Current sales',   // 현재 매출
            SalesTotal: 'Total sales', // 총 매출

            PositionSales: 'Sales',
            PositionAgent: 'Agent',
            PositionSalesMaster: 'SalesMaster',
            PositionDiamond: 'Diamond Master',
            PositionRose: 'SharonRose Master',
            PositionStar: 'Star Master',
            PositionRoyal: 'Royal Master',
            PositionCrown: 'Crown Master',
            PositionImperial: 'Imperial Master',
    
            ProductPre: 'ProductPre',
            NextProducts: 'Next',
    
            ButtonLogin: 'ButtonLogin',

            AtomyNewProduct: 'New products',
            AtomyBestProduct: 'Popular products',

            FallbackBotAny: 'FallbackBotAny',
            FallbackBotMember: 'FallbackBotMember',
            FallbackThird: 'FallbackBotThird',
    
            ButtonNewProduct: 'View new Atomy products',
            OrderList: 'OrderList',
            ButtonPlan: 'ButtonPlan',
            ButtonLowerSales: 'ButtonLowerSales',
            ButtonRecommendProduct: 'ButtonRecommendProduct',
            ButtonRecentIncome: 'ButtonRecentIncome',

            CurrencyFormat: '{num} KRW',
            CurrencyFormat1: '<strong><em>{num}</em></strong> KRW',
            CurrencyFormat2: '<strong>{num}</strong> KRW',   // ...원
            CurrencyFormat3: '<strong class="price">{num}</strong> KRW',
            CurrencyFormatBold: '<strong class="bold">{num}</strong> KRW',
    
            Category: 'Category', // '카테고리',
            BestKeyword: 'Best keywords', // '인기상품 키워드',    

            NoticeBot: 'NoticeBot',// '새로운 공지사항이 있는지 확인해보세요.',
            Views: 'Views',// '조회수',        
    
            TelNumber: 'TelNumber',// '전화번호',
            Address: 'Address',// '주소'
            Count: 'Count', // '{num}건 / 총 {total}건',
    
            CardNumber: 'CardNumber',// '카드번호',
            ChatPlaceholder: "Please enter your question",
            Items: '{num}case',
            TotalPv: 'Total PV',
            Faq: 'FAQ', //퀵메뉴 faq
            Invite: 'Contact Agent',
            UpdateNotice: '[챗봇이용제한안내]<br>앗 ! 보다 원활한 챗봇 이용을 위한 업데이트가 있을 예정이에요.<br>업데이트 시간동안은 챗봇 사용이 제한될 예정이니 사용에 참고 부탁드릴게요!<br>- 업데이트 일시 : 2022.05.13(금) 00시~02시<br> 감사합니다.',
            UpdateDisable: 'We are updating chatbot now.<br> Sorry about we can’t give you the answer...<br> But if you contact with the manager of Center,<br> you will get the answer from your request. '



        },    
    }
}

GentleLang.orderStatus = function(type){
    let state = '';
    switch (type) {
        case 1: // 주문완료
            state =  GentleLang.translate(GentleLang.type.Ordered); 
            break;
        case 2: // 결제완료
            state =  GentleLang.translate(GentleLang.type.Paid); 
            break;
        case 11: // 주문취소
            state =  GentleLang.translate(GentleLang.type.CancelOrder); 
            break;
        case 12: // 결제취소
            state =  GentleLang.translate(GentleLang.type.CancelPay); 
            break;
        case 13: // 미결제마감        
            state =  GentleLang.translate(GentleLang.type.Unpaid); 
            break;
        case 101: // 배송준비중           
            state =  GentleLang.translate(GentleLang.type.ReadyShip); 
            break;
        case 102: // 배송중           
            state =  GentleLang.translate(GentleLang.type.Delivery); 
            break;
        case 103: // 배송완료  
            state =  GentleLang.translate(GentleLang.type.DeliveryDone); 
            break;
        default:
            break;
    }
    return state;
}

GentleLang.mastershipType = function(value){
    // 1(판매원), 2(에이전트), 3(세일즈마스터), 4(다이아몬드), 5(샤론로즈), 6(스타), 7(로얄), 8(크라운), 9(임페리얼)
    switch (value) {
        case 1:
            return GentleLang.translate(GentleLang.type.PositionSales);
        case 2:
            return GentleLang.translate(GentleLang.type.PositionAgent);
        case 3:
            return GentleLang.translate(GentleLang.type.PositionSalesMaster);
        case 4:
            return GentleLang.translate(GentleLang.type.PositionDiamond);
        case 5:
            return GentleLang.translate(GentleLang.type.PositionRose);
        case 6:
            return GentleLang.translate(GentleLang.type.PositionStar);
        case 7:
            return GentleLang.translate(GentleLang.type.PositionRoyal);
        case 8:
            return GentleLang.translate(GentleLang.type.PositionCrown);
        case 9:
            return GentleLang.translate(GentleLang.type.PositionImperial);
    }
    throw new Error(`무효한 등급입니다. : ${value}`);;
}

GentleLang.translate = function(type, params){
    let {lang, persona} = GentleAppState;
    lang = lang.toUpperCase()

    if(lang.toUpperCase() !== GentleLang.lang.KR && lang !== GentleLang.lang.ENG) throw new Error('언어타입이 유효하지 않습니다.');

    var setPersona = persona === GentleLang.persona.TOMMY ? GentleLang.tomy : GentleLang.papa;
    var set = lang.toUpperCase() === GentleLang.lang.KR ? setPersona.kr : setPersona.eng;
    var str = set[type]; // set[type];

    if(str === undefined) throw new Error(`문장타입이 유효하지 않습니다. : ${type}`);

    return str.GentleFormat(params);
}

// lang pack을 따로 지정 받는 타입
GentleLang.translateService = function(pack, type, params){
    let {lang, persona} = GentleAppState;
    lang = lang.toUpperCase()

    if(lang !== GentleLang.lang.KR && lang !== GentleLang.lang.ENG) throw new Error('언어타입이 유효하지 않습니다.');

    var setPersona = persona === GentleLang.persona.TOMMY ? pack.tomy : pack.papa;
    var set = lang.toUpperCase() === GentleLang.lang.KR ? setPersona.kr : setPersona.eng;
    var str = set[type]; // set[type];

    if(str === undefined) throw new Error(`문장타입이 유효하지 않습니다. : ${type}`);

    return str.GentleFormat(params);
}

Object.freeze(GentleLang);

export default GentleLang;
